/// <reference path="../../lib/tsd.d.ts" />

import {Options, ReceiverInterface} from "./receiver";
import {Collection} from "../lib/event-interface";
import {JoinedRoomModeSpecific} from "../chatserver/sx-server";
import ajaxAPI from "../api/ajax-api";
import logging from "../utils/log";

export class OpenVIDUReceiver implements ReceiverInterface
{
	private isPaused: boolean = true;

	currentStream: string;

	private TAG = "[Sxc.Chat.OpenVIDUReceiver]";

	private $container : JQuery;
	private player : any = null;

	private initialized = false;
	private ready       = false;
	private played      = false;

	private lastServer : string;
	private lastStream : string;

	private muteForced : boolean = false;
	private volume : number = null;

	public evt : Collection;
	private currentServer: string;

	constructor (private params : Options)
	{
		this.evt = new Collection("receiver");
	}

	private initPlayer() : void {
		//this.$container = $("#sxcc-obj-wrapper");

		$('#sxcc-obj-video').remove();

		//let videoElement = document.getElementById('sxcc-obj-video');
		let videoElement = $('<video>').attr('id', 'sxcc-obj-video');

		$("#sxcc-obj-wrapper").append(videoElement);

		// @ts-ignore
		//this.player = new OvStreamViewer(this.$container.attr('id'), {
		this.player = new OvStreamViewer(document.getElementById('sxcc-obj-video'), {
			//apiUrl: "https://ov.test.org:7000/api"
		});

		this.player.init(() => {});
	}

	public getCurrentName(): string
	{
		return "OpenVIDUReceiver";
	}

	public getVideoObject() {
		return this.player;
	}

	public setFlag(s: string, enabled : boolean = false): void
	{
		this.$container[enabled ? "addClass" : "removeClass"](s);
	}

	public static isSupported()
	{
		// @ts-ignore
		return this.player.browserSupportsOpenVidu;
	}

	isReady()
	{
		return this.ready;
	}

	isPlayed()
	{
		return this.played;
	}

	// @TODO container csak a kompatibilitás miatt kerül átadásra, de itt nincs használatban
	initialize($container, standalone = true)
	{
		logging.log(this.TAG, "initialize", this.initialized);

		if (this.initialized) return;

		this.$container = $container;

		if (standalone)
		{
			this.$container.on("mouseenter", (e) => {
				this.evt.trigger("mouseenter");
			});

			this.$container.on("mouseleave", (e) => {
				this.evt.trigger("mouseleave");
			});
		}

		this.initialized = true;

		this._onReady(null);
	}

	isInitialized()
	{
		return this.initialized;
	}

	public connect()
	{
	}

	disconnect()
	{
		logging.log(this.TAG, "[disconnect]");
		this.stop();
	}

	play(playType : string, tokenRaw : string, streamId : string, serverId : string) : void
	{
		if(this.player == null) { this.initPlayer(); }

		logging.log(this.TAG, "play", playType, tokenRaw, streamId, serverId);

		//if ("streamPrefix" in window) {
		//	streamName = window["streamPrefix"] + streamId;
		//}

		console.error('play', playType, tokenRaw, streamId, serverId);

		this.played = false;

		if(playType == 'openvidu-free') {
			ajaxAPI.get(tokenRaw)
				.then((responseJSON) => {
					this.playConnect(responseJSON['token']);
				});
		} else if(playType == 'openvidu') {
			this.playConnect(tokenRaw);
		}
	}

	private playConnect(subscriberToken : string) : void {
		let _this = this;

		_this.player.connect(subscriberToken, function(err) {
			if(_this.player.autoSubscribe) {
				//
			} else {
				_this.player.subscribe();
			}

			logging.log(_this.TAG, "play.onReady");
			_this._onPlaying(null);
			_this.$container.css("opacity", 1);
		});
	}

	setVolume(volume : number):void
	{
		logging.log(this.TAG, "setVolume", volume);

		this.volume = volume;

		if (!this.isReady() || !this.isPlayed()) return;

		//let videoElement = <HTMLVideoElement>document.getElementById( this.player.subscriber.id );
		let videoElement = <HTMLVideoElement>document.getElementById('sxcc-obj-video');
		videoElement.muted = (this.volume == 0);
		videoElement.volume = this.volume / 100;
	}

	stop():void
	{
		logging.log(this.TAG, "Stop", this.isReady());

		if (!this.isReady()) return;

		// @TODO itt kell a playert pause állapotra állítani
	}

	destroy()
	{
		logging.log(this.TAG, "destroy");

		this.ready = false;
	}

	forceMute(forced: boolean): void
	{
		logging.log(this.TAG, "forceMute", forced);

		this.muteForced = forced;

		this.setVolume(this.volume);
	}

	clear()
	{
		this.$container.css("opacity", 0);
	}

	restoreLastStream() : void {
		logging.log(this.TAG, "RestoreLastStream", this.lastServer, this.lastStream);

		// @TODO el kell indítani a lastServer és a lastStream adatai lejátszását
	}

	reStreamIfChanged(serverID:string, streamName:string)
	{
		// no-op
	}

	/**
	 * This method called when the player object is ready.
	 */
	public _onReady(...args)
	{
		logging.log(this.TAG, "[_onReady]", args);

		this.ready = true;

		this.evt.trigger("ready");
	}

	/**
	 * Triggered when the playback starts after a play call
	 * @param args
	 * @private
	 */
	public _onPlaying(...args)
	{
		logging.log(this.TAG, "[_onPlaying]", args);
		this.evt.trigger("playing");

		this.played = true;

		this.setVolume(this.volume);
	}

	/**
	 * Triggered when the stream's dimension is changed
	 */
	public _onVideoDimension(w, h)
	{
		logging.log(this.TAG, "[_onVideoDimension]", w, h);
		this.evt.trigger("videoDimension", w, h);
	}

	public _onPlayFailed(data)
	{
		logging.log(this.TAG, "_onPlayFailed", data);

		data.stream = {
			server: this.currentServer,
			stream: this.currentStream,
		};

		this.evt.trigger("playFailed", data);
	}
}
